// Profile Registration Helpers

// Help determine flow that's entered AFTER email/workspace verification
// ProjectConfig.registrationProfileFlow sets the screens and order.

import { projectConfig } from "../project-info/projectConfig";
import { authentication } from '../models/Authentication';

// the number of steps before profile flow starts:
const standardAccountSteps = 2; // standard flow has two steps: create account, verify email (workspace code is not counted, and has no step text).
const ssoAccountSteps = 1; // sso flow has one step
const userCreationSteps = authentication.okta ? ssoAccountSteps : standardAccountSteps;
const profileSteps = projectConfig.registerProfileSteps;

// Get the index of a step by screen or path
const getStepIndex = (curentStep) => {
  return profileSteps.findIndex(step => step.screen === curentStep || step.path === curentStep);
};


// These getScreen functions returns an index of projectConfig.registerProfileSteps with .screen and .path values.
// Mobile app uses .screen with react-navigation, web uses .path with react-router.
// currentScreen can either be .screen or .path
function getFirstScreen() {
  if (profileSteps.length > 0) {
    return profileSteps[0];
  }
} 
  
function getNextScreen(currentScreen) {
  const currentIndex = getStepIndex(currentScreen);
  const nextIndex = currentIndex + 1;
  return profileSteps[nextIndex]; // Returns undefined if no next screen exists
}
  
function getPreviousScreen(currentScreen) {
  const currentIndex = getStepIndex(currentScreen);
  const prevIndex = currentIndex - 1;
  return profileSteps[prevIndex]; // Returns undefined if no previous screen exists
}
  
// offset the step count by userCreationSteps (profileFlow is entered after user creation steps which could be different depending on SSO.)
function getStepText(currentScreen) {
  const totalSteps = getTotalSteps();
  const currentStepIndex = getStepIndex(currentScreen) + 1 + userCreationSteps;
  return `STEP ${currentStepIndex} OF ${totalSteps}`;
}
  
function getTotalSteps() {
  return profileSteps.length + userCreationSteps;
}
  
export default {
  getFirstScreen,
  getNextScreen,
  getPreviousScreen, 
  getStepText,
  getTotalSteps
};
